// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  color: #751269;
}

.block-display {
  display: block;
  width: 100%;
  margin: 0.3em 0em;
}

.path-forward {
  color: #751269;
  font-family: "Gotham-Book";
  font-size: 1em;
  font-weight: bold;
}

.header-background {
  background-color: #ecdeea;
}

.comment-date {
  color: #a9a9a9;
  font-family: "Gotham-Book";
  font-size: 0.8em;
  font-weight: 300;
  text-align: right;
}

.comment-detail {
  color: #751269;
  font-family: "Gotham-Book";
  font-size: 1em;
  font-weight: 300;
  white-space: pre;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.material-status {
  padding-bottom: 16px;
  padding-top: 5px;
}

.material-content {
  margin-left: -2px;
}

.comment-content {
  padding-left: 8px;
  margin-top: 0px;
  padding-top: 0px;
  padding-bottom: 5px;
}

.comment-div {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  margin-bottom: 5px;
  padding-top: 5px;
}

.shift-date {
  color: #4a4a4a;
  font-family: "Gotham-Book";
  font-size: 1em;
  font-weight: 500;
  line-height: 17px;
}

.row-separator {
  border-width: 1px;
  border-color: #dbdcdd;
  border-style: none none solid none;
  margin: 0.3em 0em;
}

.spacing-right {
  margin-right: 0.3em;
}

.spacing-left {
  margin-left: 0.5em;
}

ion-label {
  margin: 0.5em;
}

div {
  display: block;
}

.right-chevron-icon {
  color: var(--ion-color-primary);
  font-size: 1.5em;
  padding: 0;
  height: 24px;
  width: 24px;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.detailRow {
  display: inline-flex;
  width: 100%;
}

.detailCol-content {
  width: 90%;
}

.detailCol-icon {
  width: 10%;
  display: inline-flex;
  min-width: 40px;
  max-width: 100px;
  margin-left: auto;
  margin-right: 0px;
}

ion-icon {
  color: #751269;
}

.block-display {
  display: block;
  width: 100%;
  margin: 0.3em 0em;
}

.path-forward {
  color: #751269;
  font-family: "Gotham-Book";
  font-size: 0.8em;
  font-weight: bold;
}

.header-background {
  background-color: #ecdeea;
}

.comment-date {
  color: #a9a9a9;
  font-family: "Gotham-Book";
  font-size: 0.6em;
  font-weight: 300;
  text-align: right;
}

.comment-detail {
  color: #751269;
  font-family: "Gotham-Book";
  font-size: 0.8em;
  font-weight: 300;
  white-space: pre;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}

.comment-header {
  padding: 0.5px 1px 0.5px 1px;
  width: fit-content;
  border-radius: 1vh;
}

.material-status {
  padding-bottom: 16px;
  padding-top: 5px;
  font-size: 0.8em;
  margin-left: 0 !important;
}

.material-content {
  margin-left: -2px;
}

.comment-content {
  margin-left: 1vh;
  margin-top: 5px;
  padding-top: 0px;
  padding-bottom: 5px;
  padding-left: 3px;
  font-size: 0.8em;
  background-color: #F0F1F1;
  border-radius: 10px;
}

.comment-div {
  margin-bottom: 5px;
  padding-top: 5px;
  background-color: #F0F1F1;
  border-radius: 10px;
}

.shift-date {
  color: #4a4a4a;
  font-family: "Gotham-Book";
  font-size: 0.8em;
  font-weight: 500;
  line-height: 17px;
}

.row-separator {
  border-width: 1px;
  border-color: #dbdcdd;
  margin: 0.3em 0em;
}

.spacing-right {
  margin-right: 0.3em;
}

.spacing-left {
  margin-left: 0.5em;
}

ion-label {
  margin: 0.5em;
}

div {
  display: block;
}

.right-chevron-icon {
  color: var(--ion-color-primary);
  font-size: 1.5em;
  padding: 0;
  height: 24px;
  width: 24px;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
}

.detailRow {
  display: inline-flex;
  width: 100%;
}

.detailCol-content {
  width: 90%;
}

.detailCol-icon {
  align-items: center;
  display: flex;
}

.center-icon {
  display: flex;
  align-items: center;
}

@media only screen and (max-width: 600px) {
  .shift-date {
    font-size: 0.5em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/note-detail/note-detail.component.scss"],"names":[],"mappings":"AAGA;EACE,cAAA;AAFF;;AAKA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;AAFF;;AAKA;EACE,yBAAA;AAFF;;AAKA;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAFF;;AAKA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kCAAA;AAFF;;AAKA;EACE,oBAAA;EACA,gBAAA;AAFF;;AAKA;EACE,iBAAA;AAFF;;AAKA;EAGE,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAJF;;AAQA;EACE,0CAAA;EACA,kBAAA;EACA,gBAAA;AALF;;AAQA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;AALF;;AAQA;EACE,iBAAA;EACA,qBAAA;EACA,kCAAA;EACA,iBAAA;AALF;;AAQA;EACE,mBAAA;AALF;;AAQA;EACE,kBAAA;AALF;;AAQA;EACE,aAAA;AALF;;AAQA;EACE,cAAA;AALF;;AAQA;EACE,+BAAA;EACA,gBAAA;EAEA,UAAA;EAEA,YAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAPF;;AAUA;EACE,oBAAA;EACA,WAAA;AAPF;;AAUA;EACE,UAAA;AAPF;;AAUA;EACE,UAAA;EACA,oBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AAPF;;AAaA;EACE,cAAA;AAVF;;AAaA;EACE,cAAA;EACA,WAAA;EACA,iBAAA;AAVF;;AAaA;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,yBAAA;AAVF;;AAaA;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAVF;;AAaA;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2BAAA;EACA,kCAAA;AAVF;;AAaA;EACE,4BAAA;EACA,kBAAA;EACA,kBAAA;AAVF;;AAaA;EACE,oBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAVF;;AAaA;EACE,iBAAA;AAVF;;AAaA;EAGE,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAZF;;AAgBA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,cAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,iBAAA;EACA,qBAAA;EACA,iBAAA;AAbF;;AAgBA;EACE,mBAAA;AAbF;;AAgBA;EACE,kBAAA;AAbF;;AAgBA;EACE,aAAA;AAbF;;AAgBA;EACE,cAAA;AAbF;;AAgBA;EACE,+BAAA;EACA,gBAAA;EAEA,UAAA;EAEA,YAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;AAfF;;AAkBA;EACE,oBAAA;EACA,WAAA;AAfF;;AAkBA;EACE,UAAA;AAfF;;AAkBA;EACE,mBAAA;EACA,aAAA;AAfF;;AAkBA;EACE,aAAA;EACA,mBAAA;AAfF;;AAkBA;EACE;IACE,gBAAA;EAfF;AACF","sourcesContent":["// @import \"mixins/app.mixins.scss\";\n@import \"../../theme/mixins/app.mixins.scss\";\n\nion-icon {\n  color: #751269;\n}\n\n.block-display {\n  display: block;\n  width: 100%;\n  margin: 0.3em 0em;\n}\n\n.path-forward {\n  color: #751269;\n  font-family: \"Gotham-Book\";\n  font-size: 1em;\n  font-weight: bold;\n}\n\n.header-background {\n  background-color: #ecdeea;\n}\n\n.comment-date {\n  color: #a9a9a9;\n  font-family: \"Gotham-Book\";\n  font-size: 0.8em;\n  font-weight: 300;\n  text-align: right;\n}\n\n.comment-detail {\n  color: #751269;\n  font-family: \"Gotham-Book\";\n  font-size: 1em;\n  font-weight: 300;\n  white-space: pre;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.material-status {\n  padding-bottom: 16px;\n  padding-top: 5px;\n}\n\n.material-content {\n  margin-left: -2px;\n}\n\n.comment-content {\n  // overflow: auto;\n  // max-height: 70px;\n  padding-left: 8px;\n  margin-top: 0px;\n  padding-top: 0px;\n  padding-bottom: 5px;\n}\n\n\n.comment-div {\n  box-shadow: 0 4px 16px rgba(0, 0, 0, .12);\n  margin-bottom: 5px;\n  padding-top: 5px;\n}\n\n.shift-date {\n  color: #4a4a4a;\n  font-family: \"Gotham-Book\";\n  font-size: 1em;\n  font-weight: 500;\n  line-height: 17px;\n}\n\n.row-separator {\n  border-width: 1px;\n  border-color: #dbdcdd;\n  border-style: none none solid none;\n  margin: 0.3em 0em;\n}\n\n.spacing-right {\n  margin-right: 0.3em;\n}\n\n.spacing-left {\n  margin-left: 0.5em;\n}\n\nion-label {\n  margin: 0.5em;\n}\n\ndiv {\n  display: block;\n}\n\n.right-chevron-icon {\n  color: var(--ion-color-primary);\n  font-size: 1.5em;\n\n  padding: 0;\n\n  height: 24px;\n  width: 24px;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.detailRow {\n  display: inline-flex;\n  width: 100%;\n}\n\n.detailCol-content {\n  width: 90%;\n}\n\n.detailCol-icon {\n  width: 10%;\n  display: inline-flex;\n  min-width: 40px;\n  max-width: 100px;\n  margin-left: auto;\n  margin-right: 0px;\n}\n\n// @import \"mixins/app.mixins.scss\";\n@import \"../../theme/mixins/app.mixins.scss\";\n\nion-icon {\n  color: #751269;\n}\n\n.block-display {\n  display: block;\n  width: 100%;\n  margin: 0.3em 0em;\n}\n\n.path-forward {\n  color: #751269;\n  font-family: \"Gotham-Book\";\n  font-size: .8em;\n  font-weight: bold;\n}\n\n.header-background {\n  background-color: #ecdeea;\n}\n\n.comment-date {\n  color: #a9a9a9;\n  font-family: \"Gotham-Book\";\n  font-size: 0.6em;\n  font-weight: 300;\n  text-align: right;\n}\n\n.comment-detail {\n  color: #751269;\n  font-family: \"Gotham-Book\";\n  font-size: .8em;\n  font-weight: 300;\n  white-space: pre;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n\n.comment-header {\n  padding: .5px 1px .5px 1px;\n  width: fit-content;\n  border-radius: 1vh;\n}\n\n.material-status {\n  padding-bottom: 16px;\n  padding-top: 5px;\n  font-size: .8em;\n  margin-left: 0 !important;\n}\n\n.material-content {\n  margin-left: -2px;\n}\n\n.comment-content {\n  //@at-root: auto;\n  // max-height: 70px;\n  margin-left: 1vh;\n  margin-top: 5px;\n  padding-top: 0px;\n  padding-bottom: 5px;\n  padding-left: 3px;\n  font-size: .8em;\n  background-color: #F0F1F1;\n  border-radius: 10px;\n}\n\n\n.comment-div {\n  margin-bottom: 5px;\n  padding-top: 5px;\n  background-color: #F0F1F1;\n  border-radius: 10px;\n}\n\n.shift-date {\n  color: #4a4a4a;\n  font-family: \"Gotham-Book\";\n  font-size: .8em;\n  font-weight: 500;\n  line-height: 17px;\n}\n\n.row-separator {\n  border-width: 1px;\n  border-color: #dbdcdd;\n  margin: 0.3em 0em;\n}\n\n.spacing-right {\n  margin-right: 0.3em;\n}\n\n.spacing-left {\n  margin-left: 0.5em;\n}\n\nion-label {\n  margin: 0.5em;\n}\n\ndiv {\n  display: block;\n}\n\n.right-chevron-icon {\n  color: var(--ion-color-primary);\n  font-size: 1.5em;\n\n  padding: 0;\n\n  height: 24px;\n  width: 24px;\n  margin: auto;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0;\n}\n\n.detailRow {\n  display: inline-flex;\n  width: 100%;\n}\n\n.detailCol-content {\n  width: 90%;\n}\n\n.detailCol-icon {\n  align-items: center;\n  display: flex;\n}\n\n.center-icon {\n  display: flex;\n  align-items: center;\n}\n\n@media only screen and (max-width: 600px) {\n  .shift-date {\n    font-size: .5em;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
